// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Dropzone from 'vue2-dropzone'
import VueCookie from 'vue-cookie'


Vue.config.productionTip = false
Vue.use(Dropzone)
Vue.use(VueCookie)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js